import type { ShiftEmployeeWeeklyLimits, ShiftEmployeeWeeklyCounts } from 'shared-models';
import { EMPLOYEE_LIMIT_LABELS, getEmployeeLimitWarnings } from '../utils/employee-limits.utils';

export function EmployeeLimitWarnings({ status, counts, outdated, onRefresh, refreshDisabled }: {
  status?: ShiftEmployeeWeeklyLimits | null; counts?: ShiftEmployeeWeeklyCounts; outdated?: boolean; onRefresh?: () => void; refreshDisabled?: boolean;
}) {
  if (!status) return null;
  const warnings = getEmployeeLimitWarnings(status.limits, counts ?? status.counts);
  if (!warnings.length && !outdated) return null;
  return <section aria-label="התראות שבועיות">
    <h3>התראות שבועיות</h3>
    <p>{status.weekStartDate}</p>
    {outdated ? <button type="button" className="secondaryAction" disabled={refreshDisabled} onClick={onRefresh}>רענון התראות</button>
      : <ul>{warnings.map(warning => <li key={warning.key}>{EMPLOYEE_LIMIT_LABELS[warning.key]}: {warning.actual} / {warning.limit}</li>)}</ul>}
  </section>;
}